export interface DocumentCapture {
  documentNumber: string;
  documentType: string;
  birthdate: string;
  expirationDate: string;
}

export interface DocumentCaptureRequest {
  backBase64: string;
  backFormat: keyof typeof Format;
  frontBase64: string;
  frontFormat: keyof typeof Format;
}

export interface Document {
  documentNumber: string;
  documentType: string;
  birthdate: string;
  expirationDate: string;
}

export enum Format {
  TIF,
  JPG,
  BMP,
  PNG
}

export enum UpdateDNIErrorCodes {
  UPDATE_DOCUMENT_ERROR_RECOVERABLE = 'UPDATE_DOCUMENT_ERROR_RECOVERABLE',
  UPDATE_DOCUMENT_ERROR = 'UPDATE_DOCUMENT_ERROR'
}

export enum DocumentStatusErrorCodes {
  DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND'
}
